import React from 'react'
// import TextInput from 'glic-ui-components/dist/js/TextInput';
// import FormControl from 'glic-ui-components/dist/js/FormControl';
import { FormControl, TextInput } from 'glic-ui-components';
const TextField = ({ value, onTextChange, Id, title, required, type, width, isDisabled, validations, ariaLabelledby }) => {
    return (
        <div className="row">
            <div className='col-12'>
                {required == true ?
                    <FormControl
                        isDisabled={false}
                        validations={validations}
                        // validations={{
                        //                                     // date: { message: 'Enter a valid phone number', regex: /^\d{10}$/ },
                        //                                     // numeric: true,
                        //                                     required: { message: 'Field is required.' },
                        //                                 }}
                        validateOnChange
                        validateOnBlur
                    // onValidate={((result) => console.log('Text input validation result: ', result))}
                    >
                        <TextInput
                            id={Id}
                            name={Id}
                            label={title}
                            type={type}
                            onChange={onTextChange}
                            isDisabled={isDisabled}
                            value={value}
                            width={width}
                            aria-labelledby={ariaLabelledby}
                        />
                    </FormControl>
                    :
                    <TextInput
                        id={Id}
                        name={Id}
                        label={title}
                        type={type}
                        onChange={onTextChange}
                        isDisabled={isDisabled}
                        value={value}
                        width={width}
                        aria-labelledby={ariaLabelledby} />
                }
            </div>
        </div>
    )
}

export default TextField
